export * from './extension-pattern/extension-pattern.abstract';
